import * as queries from "./queries"

export const census = { queries }
